/**
 * Created by dmiller.contractor on 8/2/2016.
 */
import App from 'app/app.js';

function SchoolsService($http, $location) {
  var absUrl = $location.absUrl(),
    baseUrl = absUrl.substring(0, absUrl.indexOf('#'));

  this.getSchools = function (state, city) {
    return $http.get(baseUrl + 'pictureDayFinder/schoolsForEnroll/' + state + '/' + city, {}).then(
      function (response) {
        return response;
      },
      function errorCallback(response) {}
    );
  };
}

App.service('SchoolsService', ['$http', '$location', SchoolsService]);
